// services/functions/revokeLicenseOrgInvite.ts — typed wrapper
// around the invite revoke callable.

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  inviteId: string;
}

interface Output {
  inviteId: string;
  status: 'revoked';
  alreadyRevoked?: boolean;
}

const callable = httpsCallable<Input, Output>(
  functions,
  'revokeLicenseOrgInvite',
);

export async function revokeLicenseOrgInvite(input: Input): Promise<Output> {
  const res = await callable(input);
  return res.data;
}
